import React from 'react'
import  './style.css';

function PropsTable({props}: {
    props: Array<{
        [key: string] : string | boolean
    }>
}) {
  return (
    <table className='prop-table'>
        <tr>
            {Object.keys(props[0]).map(header =>{
                return(
                    <th className='table-heading'>{header}</th>
                )
            })}
        </tr>
        {props.map(prop =>{
            return (
                <tr className='prop-table-row'>
                    {Object.keys(prop).map(data =>{
                        return (
                            <td className='prop-table-data'>{prop[data]}</td>
                        )
                    })}
                </tr>
            )
        })}
    </table>
  )
}

export default PropsTable